import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { StyledContainer } from '../Heading/Heading.styles';
import media from '../../styles/config/mediaQueries';

const StyledBanner = styled.section`
  position: relative;
  ${({ borderColor }) =>
    borderColor ? `border-bottom: 2px solid ${theme.color[borderColor]}` : ''};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${rgba(theme.color.black, 0.5)};
  }

  h1 {
    line-height: 1.25;
  }

  ${media.mobile`
    padding-top: 61.33%;
  `}
  ${media.desktop`
    padding-top: 20.1265%;
    margin-top: -27px;

    ${StyledContainer} {
      width: 75%;
    }
  `}
`;

const StyledContent = styled.div`
  position: absolute;
  bottom: 12px;
  left: 26px;
  right: 26px;
  display: flex;
  align-items: flex-end;

  & > div {
    width: 100%;
  }

  ${media.mobile`
    p {
      ${typeStyle['font-12']};
      margin-top: 5px;
      opacity: 0.9;
    }
  `}
  ${media.desktop`
    max-width: 1162px;
    margin: 0 auto;

    & > div {
      display: flex;
      flex-wrap: wrap;
    }

    p {
      max-width: 771px;
      ${typeStyle['font-16']}
      opacity: 90%;
    }
  `}
`;

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  line-height: 1.5;
  margin: 0 -3px 0 6px;
  padding: 8px 0;
  ${typeStyle['font-10']};

  & > svg {
    margin-left: 6px;
    width: 10px;
  }
`;

const StyledBackButton = styled.button`
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background-color: ${theme.color.white};
  transform: rotate(180deg);
  align-self: center;
  margin-right: 10px;
  margin-bottom: 5px;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    transform: translate(-50%, -50%);

    path {
      fill: ${theme.color.black};
    }
  }
`;

const backgroundStyles = [
  `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  `,
];

const StyledImage = styled.img(backgroundStyles);

const StyledVideo = styled.video(backgroundStyles);

export { StyledBanner, StyledImage, StyledContent, StyledButton, StyledBackButton, StyledVideo };
